module.exports = __webpack_public_path__ + "static/invoicing_a_deal-fc36030df5aeb60e523b936bf1e48983.gif";